export const MealPlanRecipe = {
  bindings: {
    meal: '<',
    isActive: '<',
    onPreview: '&',
    onRemove: '&',
  },

  template: `
    <div class="meal-plan-recipe-row">
      <recipe-row
        recipe="$ctrl.meal.recipe"
        left-overs="$ctrl.meal.leftOvers"
        cookup="$ctrl.meal.cookup"
        on-preview="$ctrl.onPreview({ recipe: recipe })">
        <button class="btn btn-link btn-sm p-0 ml-2 border-0"
          type="button"
          ng-show="$ctrl.isActive"
          ng-click="$ctrl.onRemove()">
          <i class="fa fa-2x fa-times-circle text-danger m-0"></i>
        </button>
      </recipe-row>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanRecipe.js